import React from 'react';
import SectionHeading from 'src/components/SectionHeading/SectionHeading';
import { variables } from 'src/Tenants';
import './key-handoff-keys-and-values.scss';

interface SuiteKeyValue {
  key: string;
  value: string;
}

interface KeyHandoffKeysAndValuesProps {
  items: SuiteKeyValue[];
}

const KeyHandoffKeysAndValues = ({ items }: KeyHandoffKeysAndValuesProps) => {
  return (
    <div className="key-handoff-keys-and-values">
      <div className="keys-panel">
        <SectionHeading title={`${variables.Suite} Keys`} />
        <div className="keys-panel-grid">
          {items.map((item: SuiteKeyValue, index: number) => (
            <div className="keys-panel-row" key={index}>
              <span className="keys-panel-name" title={item.key}>
                {item.key}
              </span>
              <span className="keys-panel-value" title={item.value}>
                {item.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyHandoffKeysAndValues;